import { render, staticRenderFns } from "./PitchSlide.vue?vue&type=template&id=7a4cdf2c"
import script from "./PitchSlide.vue?vue&type=script&lang=js"
export * from "./PitchSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports